import React, { useState } from "react";

// --- CSS --- //
import "../../styles/waitlist.css";
import { joinWaitlist } from "../../utilities/firestore/firestoreUtils";

const Waitlist = () => {
    const [email, setEmail] = useState("");

    const handleJoinWaitlist = async () => {
        try{
            joinWaitlist(email, setEmail)
        }
        catch{
            //Error email not added
        }
    };

    return (
        <div className="waitlist-page">
            <div className="waitlist-window">
                <h1 className="waitlist-title">Join Our Waitlist Today</h1>
                <p className="waitlist-detail">
                    Be part of the movement! Join our waitlist and show climbing gyms that our community is excited for this revolutionary product.
                </p>
                <input
                    className="waitlist-email-input"
                    type="email"
                    placeholder="email@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <div className="waitlist-action-container">
                    <button className="waitlist-action-button" id="waitlist-join-button" onClick={handleJoinWaitlist}>
                        Join Waitlist!
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Waitlist;